import log from '@/utils/consolelog'
import users from '@/api/modules/users'
import files from '@/api/modules/files'
import * as mutations from './mutations'
import generateBase64Picture from '@/utils/generateBase64Picture'

const initialState = {
	authenticated: false,
	token: null,
	uid: null,
	roles: [],
	fullname: null,
	loading: false,
	error: null,
	pushToken: null,
	syncReadings: 0,
	pictureUid: null,
	pictureB64: null,
	locale: null,
	permittedAccounts: [],
	selectedAccount: null
}

export default {
	state: Object.assign({}, initialState),
	getters: {
		getUser: state => state,
		isAuthenticated: state => state.authenticated,
		uid: state => state.uid,
		getUserLoading: state => state.loading,
		isAdmin: state => state.roles.includes('admin'),
		getPicture: state => state.pictureB64,
		getLocale: state => state.locale
	},
	mutations: {
		[mutations.SET_USER_AUTH] (state, { token, user }) {
			state.authenticated = true
			state.token = token
			state.uid = user.uid
			state.roles = user.roles
		},
		[mutations.SET_USER_DESACTIVE_PUSH_TOKEN] (state, value) {
			state.pushToken = value
		},
		[mutations.SET_USER_ACTIVE_PUSH_TOKEN] (state, value) {
			state.pushToken = value
		},
		[mutations.SET_USER_PUSH_TOKEN] (state, value) {
			state.pushToken = value
		},
		[mutations.SET_USER_NAME] (state, value) {
			state.fullname = value
		},
		[mutations.SET_USER_PICTURE_UID] (state, value) {
			state.pictureUid = value
		},
		[mutations.SET_USER_PICTURE_B64] (state, value) {
			state.pictureB64 = value
		},
		[mutations.SET_USER_LOADING] (state, value) {
			state.loading = value
		},
		[mutations.SET_USER_ERROR] (state, value) {
			state.error = value
		},
		[mutations.SET_USER_SYNC] (state, value) {
			state.syncReadings = value
		},
		[mutations.SET_USER_LOCALE] (state, value) {
			state.locale = value
		},
		[mutations.SET_USER_PERMITTED_ACCOUNTS] (state, value) {
			state.permittedAccounts = value
		},
		[mutations.SET_USER_SELECTED_ACCOUNT] (state, value) {
			state.selectedAccount = value
			window.localStorage.setItem('account', state.uid)
			window.localStorage.setItem('selectedAccount', value)
		},
		[mutations.CLEAR_USER] (state) {
			Object.assign(state, initialState)
		}
	},
	actions: {
		setAuthenticated ({ commit }, user) {
			commit(mutations.SET_USER_AUTH, user)
		},
		activePushToken ({ commit, state }, { context, token }) {
			const model = {
				token: token
			}

			console.log(model)

			users.notifications.setDeviceActive(context, state.uid, model).then(response => {
				log.log('store', 'users.pushNotifications.setActiveDevice OK', response)()
				commit(mutations.SET_USER_ACTIVE_PUSH_TOKEN, token)
			}).catch(error => {
				log.error('store', 'users.pushNotifications.setActiveDevice ERROR', error)()
			})

		},
		desactivePushToken ({ commit, state }, { context, token }) {

			const model = {
				token: token
			}

			users.notifications.setDeviceDesactive(context, state.uid, model).then(response => {
				log.log('store', 'users.pushNotifications.setDesactiveDevice OK', response)()
				commit(mutations.SET_USER_DESACTIVE_PUSH_TOKEN, token)
			}).catch(error => {
				log.error('store', 'users.pushNotifications.setDesactiveDevice ERROR', error)()
			})

		},
		setPushToken ({ commit, state }, { context, token }) {
			users.notifications.getDevices(context, state.uid).then(response => {
				log.log('store', 'users.pushNotifications.getDevices OK', response)()
				const exists = response.body.some(e => e.token === token)
				log.log('store', 'Push Notifications TOKEN already exists in backend:', exists)()
				if (!exists) {
					const model = {
						type: 3, // TYPE_PUSH
						name: navigator.userAgent,
						token: token
					}
					users.notifications.setDevice(context, state.uid, model).then(response => {
						log.log('store', 'users.pushNotifications.setDevice OK', response)()
						commit(mutations.SET_USER_PUSH_TOKEN, token)
					}).catch(error => {
						log.error('store', 'users.pushNotifications.setDevice ERROR', error)()
					})
				}
			}).catch(error => {
				log.error('store', 'users.pushNotifications.getDevices ERROR', error)()
			})
		},
		setUserPicture ({ commit }, { pictureUid, pictureB64 }) {
			commit(mutations.SET_USER_PICTURE_UID, pictureUid)
			commit(mutations.SET_USER_PICTURE_B64, pictureB64)
		},
		setUserLocale ({ commit }, locale) {
			commit(mutations.SET_USER_LOCALE, locale)
		},
		setUserSelectedAccount({ commit }, value) {
			commit(mutations.SET_USER_SELECTED_ACCOUNT, value)
		},
		getUser ({ commit, state }, { context }) {
			commit(mutations.SET_USER_LOADING, true)
			const getPictureData = function (context, user_uid, file_uid) {
				return files.get(context, user_uid, null, file_uid)
					.then(response => {
						log.log('store user picture', 'files.get OK', response)()
						return response.body
					}).catch(error => {
						log.error('store user picture', 'files.get ERROR', error)()
					})
			}
			const getPictureMetadata = function (context, user_uid, file_uid) {
				return files.getMetadata(context, user_uid, null, file_uid)
					.then(response => {
						log.log('store user picture', 'files.getMetadata OK', response)()
						return response.body
					}).catch(error => {
						log.error('store user picture', 'files.getMetadata ERROR', error)()
					})
			}
			const getPicture = function (context, user_uid, file_uid) {
				Promise.all([getPictureData(context, user_uid, file_uid), getPictureMetadata(context, user_uid, file_uid)])
					.then(([data, metadata]) => {
						log.log('store user picture', 'getPicture() OK', [data, metadata])()
						commit(mutations.SET_USER_PICTURE_B64, generateBase64Picture(data, metadata.extension))
					}).catch(error => {
						log.error('store user picture', 'getPicture() ERROR', error)()
					}).finally(() => {
						commit(mutations.SET_USER_LOADING, false)
					})
			}
			const getPermittedUsers = function (context, user_uid) {
				users.getPermittedUsers(context, user_uid)
					.then(response => {
						log.log('store user permitted accounts', 'users.getPermittedUsers OK', response)()
						commit(mutations.SET_USER_PERMITTED_ACCOUNTS, response.body)
					})
					.catch(error => {
						log.error('store user permitted accounts', 'users.getPermittedUsers ERROR', error)()
					})
			}
			users.get(context)
				.then(response => {
					log.log('store', 'users.get OK', response)()
					const fullname = response.body.fullname
					const pictureUid = response.body.picture
					commit(mutations.SET_USER_NAME, fullname)
					const account = window.localStorage.getItem('account')
					const selectedAccount = account == state.uid ? window.localStorage.getItem('selectedAccount') || state.uid : state.uid
					commit(mutations.SET_USER_SELECTED_ACCOUNT, selectedAccount)
					if (pictureUid) {
						commit(mutations.SET_USER_PICTURE_UID, pictureUid)
						getPicture(context, state.uid, pictureUid)
					} else {
						commit(mutations.SET_USER_LOADING, false)
					}
					//getPermittedUsers(context, state.uid)
				}).catch(error => {
					log.error('store', 'users.get ERROR', error)()
					commit(mutations.SET_USER_ERROR, error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js